enum ETimeframes {
  second = '1S',
  fiveSeconds = '5S',
  tenSeconds = '10S',
  minute = '1',
  threeMinutes = '3',
  fiveMinutes = '5',
  fifteenMinutes = '15',
  thirtyMinutes = '30',
  hour = '60',
  twoHours = '120',
  fourHours = '240',
  sixHours = '360',
  eightHours = '480',
  twelveHours = '720',
  day = '1D',
  threeDays = '3D',
  week = '1W',
  month = '1M',
  year = '12M',
}

enum EParsedTimeframes {
  second = '1s',
  fiveSeconds = '5s',
  tenSeconds = '10s',
  minute = '1m',
  threeMinutes = '3m',
  fiveMinutes = '5m',
  fifteenMinutes = '15m',
  thirtyMinutes = '30m',
  hour = '1h',
  twoHours = '2h',
  fourHours = '4h',
  sixHours = '6h',
  eightHours = '8h',
  twelveHours = '12h',
  day = '1D',
  threeDays = '3D',
  week = '1W',
  month = '1M',
  year = 'year',
}

export { ETimeframes, EParsedTimeframes };
